import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { ReglementFournisseurState, state } from '@/modules/ReglementsFournisseurs/store/state';
import { mutations } from '@/modules/ReglementsFournisseurs/store/mutations';
import { actions } from '@/modules/ReglementsFournisseurs/store/actions';
import { getters } from '@/modules/ReglementsFournisseurs/store/getters';

const module: Module<ReglementFournisseurState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { ReglementFournisseurState };

